import OrderGridView from "../../orders/OrderGridView";

const OrdersTab = ({ userId }: { userId: string }) => {
  return <OrderGridView userId={userId} columnsToHide={["appliedUserName", "programName"]} />;
};

export default OrdersTab;
